






























import Vue from 'vue'
import Component from "vue-class-component";
import { Prop } from 'vue-property-decorator';
import {Action} from "vuex-class";
import { getErrorMessage } from '@/utils/notify-helper';

@Component
export default class LoginForm extends Vue {
  @Action("authRequest") authRequest: any;
  @Action("getAllowedPages") actionGetAllowedPages: any;
  @Action("getProfile") actionGetProfile: any;

  private form = {
    username: '',
    password: ''
  }

  async submit() {
    this.$emit('isProgress', true)
    this.$emit('errorMessage', undefined)
    try {
      const authResp = await this.authRequest(this.form);
      let allowedPages = await this.actionGetAllowedPages()
      localStorage.setItem('lk-allowedPages', JSON.stringify(allowedPages))
      this.$router.push(localStorage.getItem('lk-lastUrl') || '/');
      if (authResp.data.isADUser) {
        const profileResp =  await this.actionGetProfile()
        if (profileResp.data.email) {
          localStorage.setItem('lk-username', profileResp.data.email)
          this.$store.commit('setUsername', profileResp.data.email)
        }
      }
    } catch (e) {
      const errorMessage = getErrorMessage(e)
      this.$emit('errorMessage', errorMessage)
    } finally {
      this.$emit('isProgress', false)
    }
  }

}
